import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import DocumentStorageAndArchivingPage from '@/v2/components/pages/public-pages/document-storage-and-archiving-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/document-storage-and-archiving-page'

interface DocumentStorageAndArchivingPageProps {}

const Page: React.FC<DocumentStorageAndArchivingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.document_storage_and_archiving.title ?? ''}
        keywords={META_CONTENTS.document_storage_and_archiving?.keywords ?? ''}
        description={META_CONTENTS.document_storage_and_archiving?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />
      <DocumentStorageAndArchivingPage />
    </>
  )
}

export default Page
